import { RegistrationStatuses } from '@klp/contractregistration/services/rtkApi';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Tooltip } from '@klp/design/Tooltip';
import { Box, IconButton } from '@material-ui/core';
import React from 'react';
import { MenuPopper } from '../../MenuPopper';
import type { IContractToRegistration } from '@klp/contractregistration/classes/IContractToRegistration';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { ContractRegistrationRoutes } from '@forvalter/routing/Routes';
import type { useHistory } from 'react-router-dom';

type ActionsProps = {
    line: IContractToRegistration;
    dokumentId: string | undefined;
    status: string;
    history: ReturnType<typeof useHistory>;
    handleShareDocument: (
        dokumentId: string,
        event: React.MouseEvent<HTMLElement>,
    ) => void;
    handleClosePopper: () => void;
    handleTogglePopper: (
        id: string,
        event: React.MouseEvent<HTMLElement>,
    ) => void;
    openPopperId: string | null;
    anchorEl: HTMLElement | null;
};

export const Actions = ({
    line,
    dokumentId,
    status,
    history,
    handleShareDocument,
    handleClosePopper,
    handleTogglePopper,
    openPopperId,
    anchorEl,
}: ActionsProps) => {
    const shareDocumentStatuses = [
        RegistrationStatuses.NY,
        RegistrationStatuses.TIL_QA,
        RegistrationStatuses.FULLFORT,
    ];

    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center">
            {status === RegistrationStatuses.NY && (
                <Tooltip
                    translation="checkOffContract.startRegistrationButton"
                    title=""
                >
                    <Box>
                        <IconButton
                            onClick={() =>
                                history.push(
                                    ContractRegistrationRoutes.single(
                                        dokumentId ?? '',
                                    ),
                                )
                            }
                        >
                            <PlayArrowIcon />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}

            {shareDocumentStatuses.includes(status as RegistrationStatuses) && (
                <Tooltip
                    title=""
                    translation={
                        status === RegistrationStatuses.FULLFORT
                            ? 'checkOffContract.shareButtonCompleted'
                            : 'checkOffContract.shareButton'
                    }
                >
                    <Box>
                        <IconButton
                            onClick={(e) =>
                                handleShareDocument(dokumentId ?? '', e)
                            }
                        >
                            <Illustration icon={IconName.DOC_OUTBOUND} />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}

            <MenuPopper
                handleDetails={{
                    dokumentId,
                    registrationLine: line,
                }}
                handleAssignResponsible={{ dokumentId }}
                handleDownload={{
                    path: line?.filMetadata?.id,
                    name: line?.filMetadata?.name,
                }}
                open={openPopperId === line?.dokumentId}
                anchorEl={anchorEl}
                onToggle={(event) =>
                    handleTogglePopper(line?.dokumentId ?? '', event)
                }
                onClose={handleClosePopper}
            />
        </Box>
    );
};
